import { generateError } from "../api/cardApiError";
import { GlobalLogger } from "./debugLogger";

export const _handleError = (
  error: any,
  stateMachineSend: any,
  onError: any,
  stateMachineState?: any,
  type?: string
) => {
  let errorMessage = "An error occurred";

  if (error.isAxiosError === true && error.response) {
    stateMachineSend("ERROR", {
      httpCode: error.response.status,
      httpMessage: error.message,
    });

    const err = generateError(
      error.message,
      "ResponseError",
      error.response.status
    );

    errorMessage = err.message;

    if (onError) {
      onError(err);
    }
    GlobalLogger.debug(
      `ResponseError ${error.response.status} - ${error.message}`
    );
  } else if (error.isAxiosError === true && error.request) {
    stateMachineSend("ERROR", {
      httpCode: error.request.status,
      httpMessage: error.message,
    });
    const err = generateError(
      error.message,
      "RequestError",
      error.request.status
    );

    errorMessage = err.message;

    if (onError) {
      onError(err);
    }

    GlobalLogger.debug(
      `RequestError ${error.response.status} - ${error.message}`
    );
  } else if (error.isCardScanError == true) {
    let err = error;
    //avoid calling onError on 403 here
    //because it is already handled in AxiosError
    //so we don't get onError being called twice
    //when websocket fails on 403
    if (stateMachineState.context.httpCode == 403) {
      err = generateError(
        stateMachineState.context.httpMessage,
        "RequestError",
        stateMachineState.context.httpCode
      );
      stateMachineSend("ERROR", {
        httpCode: stateMachineState.context.httpCode,
        httpMessage: stateMachineState.context.httpMessage,
      });
    } else {
      stateMachineSend("ERROR");
      if (onError) {
        onError(err);
      }
    }
    errorMessage = err.message;
    GlobalLogger.debug(`isCardScanError ${error.message}`);
  } else {
    const err = generateError(error.message, type || "UnknownError", 606);
    stateMachineSend("ERROR", {
      httpCode: 606,
      httpMessage: type || "UnknownError",
    });

    errorMessage = err.message;

    if (onError) {
      onError(err);
    }
    GlobalLogger.debug(`UnknownError ${error.message}`);
    //don't change UI Status as we don't know if this error is fatal or not.
  }
  GlobalLogger.error(errorMessage);
};
